<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
  <span
    role="button"
    class="navbar-brand d-block d-lg-none ms-1"
    (click)="toggleNav()"
    >{{
      appService.selectedSite
        ? appService.selectedSite.Name +
          (appService.selectedCamera
            ? ' - ' + appService.selectedCamera.Name
            : '')
        : 'Select Camera'
    }}</span
  >
  <button
    class="navbar-toggler me-1"
    (click)="toggleNav()"
    type="button"
    data-toggle="collapse"
    data-target="#camNav">
    <fa-icon [icon]="icons.camera"></fa-icon>
  </button>
  <div
    [ngbCollapse]="navCollapsed"
    class="collapse navbar-collapse"
    id="camNav">
    <ul class="navbar-nav mx-auto">
      <!-- Prev Button -->
      <li
        [class.disabled]="appService.isImageLoading"
        class="nav-item d-none d-lg-block">
        <button
          title="Previous Camera (A)"
          type="button"
          (click)="appService.previousCamera()"
          [disabled]="
            appService.isImageLoading ||
            !appService.isImageLoaded ||
            !appService.selectedCamera
          "
          class="btn btn-primary me-1">
          <fa-icon [icon]="icons.previous"></fa-icon>
        </button>
      </li>
      <!-- End Prev Button -->
      <!-- Site Dropdown -->
      <li
        ngbDropdown
        role="button"
        #siteDropdown="ngbDropdown"
        [class.disabled]="appService.isImageLoading"
        class="nav-item nav-dropdown"
        data-boundary="viewport">
        <a class="nav-link" ngbDropdownToggle tabindex="0">
          {{
            appService.selectedSite
              ? appService.selectedSite.Name
              : 'Select Site'
          }}
        </a>
        <div ngbDropdownMenu class="scrollable-menu">
          <div
            class="dropdown-header"
            role="button"
            (click)="startStatusCheck()">
            Refresh Status
          </div>
          @for (site of appService.sites; track site; let i = $index) {
            <a
              ngbDropdownItem
              routerLinkActive="active"
              role="button"
              [routerLink]="['/view', site.Id]"
              (click)="navCollapsed = true">
              @if (site.HasError === true) {
                <fa-icon
                  [icon]="icons.exclamation"
                  class="text-danger"
                  title="{{ site.ErrorMessage }}"></fa-icon>
              } @else if (site.HasError === false) {
                <fa-icon
                  [icon]="icons.circleCheck"
                  [ngClass]="getSiteCamerasStatusClass(site)"
                  [title]="getSiteCamerasStatusTitle(site)"></fa-icon>
              } @else {
                <fa-icon
                  [icon]="icons.spinner"
                  animation="spin-pulse"
                  class="text-muted"
                  title="Checking site..."></fa-icon>
              }
              {{ site.Name }}
            </a>
          }
          @if (appService.sites === null) {
            <a ngbDropdownItem role="button">Still loading sites...</a>
          }
          @if (appService.sites && appService.sites.length === 0) {
            <a ngbDropdownItem role="button">No Sites Available</a>
          }
        </div>
      </li>
      <!-- End Site Dropdown -->

      <!-- Camera Dropdown -->
      <li
        ngbDropdown
        role="button"
        #cameraDropdown="ngbDropdown"
        [class.disabled]="appService.isImageLoading"
        class="nav-item nav-dropdown"
        data-boundary="viewport">
        <a class="nav-link" ngbDropdownToggle tabindex="0">
          {{
            appService.selectedCamera
              ? appService.selectedCamera.Name
              : 'Select Camera'
          }}
        </a>
        @if (appService.selectedSite !== null) {
          <div ngbDropdownMenu class="scrollable-menu">
            @for (
              camera of appService.selectedSite?.Cameras;
              track camera;
              let i = $index
            ) {
              <a
                ngbDropdownItem
                role="button"
                routerLinkActive="active"
                [routerLink]="['/view', camera.SiteId, camera.Id]"
                (click)="navCollapsed = true">
                @if (camera.HasError) {
                  <fa-icon
                    [icon]="icons.exclamation"
                    class="text-danger"
                    title="{{ camera.ErrorMessage }}"></fa-icon>
                } @else {
                  <fa-icon
                    [icon]="icons.video"
                    title="Camera Online"
                    class="text-success"></fa-icon>
                }
                {{ camera.Name }}
              </a>
            }
          </div>
        }
        @if (appService.selectedSite === null) {
          <div ngbDropdownMenu>
            <a ngbDropdownItem role="button">Select a site first</a>
          </div>
        }
      </li>
      <!-- End Camera Dropdown -->

      <!-- Next Button -->
      <li
        [class.disabled]="appService.isImageLoading"
        class="nav-item d-none d-lg-block">
        <button
          title="Next Camera (D)"
          type="button"
          [disabled]="
            appService.isImageLoading ||
            !appService.isImageLoaded ||
            !appService.selectedCamera
          "
          (click)="appService.nextCamera()"
          class="btn btn-primary ms-1">
          <fa-icon [icon]="icons.next"></fa-icon>
        </button>
      </li>
      <!-- End Next Button -->

      <!-- Refresh Button -->
      <li class="nav-item" [class.disabled]="this.appService.isImageLoading">
        <button
          title="Refresh Camera (R)"
          type="button"
          class="btn btn-primary ms-1"
          [disabled]="
            appService.isImageLoading ||
            !appService.isImageLoaded ||
            !appService.selectedCamera
          "
          (click)="this.appService.refreshCamera(false)">
          <fa-icon
            [icon]="icons.refresh"
            style="--fa-primary-color: limegreen"></fa-icon>
        </button>
      </li>
      <!-- End Refresh Button -->
    </ul>
    <!-- Right Side Menu Items -->
    <!-- Fullscreen Controls -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <button
          (click)="enterFullscreen()"
          [hidden]="isFullscreen || !canFullscreen"
          title="Fullscreen (F)"
          class="btn btn-dark me-1 d-none d-md-block">
          <fa-icon [icon]="icons.fullscreen" size="lg"></fa-icon>
        </button>
      </li>
      <!-- Options Dropdown -->
      <li ngbDropdown #settingsDropdown="ngbDropdown" class="nav-item ms-auto">
        <a class="nav-link" ngbDropdownToggle tabindex="0" role="button">
          <fa-icon [icon]="icons.cogs" size="lg"></fa-icon>
        </a>
        <div
          ngbDropdownMenu
          style="width: 300px"
          class="dropdown-menu dropdown-menu-end">
          <h5 class="dropdown-header">Settings</h5>
          <form #settingsForm="ngForm" class="form">
            <div class="row ps-4 pe-3 mb-3">
              <label
                for="cboAutoRefresh"
                class="col-5 col-form-label col-form-label-sm"
                >Auto Refresh</label
              >
              <div class="col-7">
                <select
                  #cboAutoRefresh
                  name="cboAutoRefresh"
                  id="cboAutoRefresh"
                  class="form-control form-control-sm form-select form-select-sm"
                  (change)="changeAutoRefreshSettings(cboAutoRefresh.value)">
                  <option value="-1">Off</option>
                  <option value="5000">5 Seconds</option>
                  <option value="10000">10 Seconds</option>
                  <option value="15000">15 Seconds</option>
                  <option value="30000">30 Seconds</option>
                </select>
              </div>
            </div>
            <div class="ps-4">
              <div class="form-check form-switch custom-switch-success">
                <input
                  [(ngModel)]="appService.autoChangeSite"
                  #chkAutoNextSite="ngModel"
                  name="chkAutoNextSite"
                  type="checkbox"
                  class="form-check-input"
                  id="chkAutoNextSite"
                  (change)="changeAutoSettings()" />
                <label class="form-check-label" for="chkAutoNextSite"
                  >Change Site Automatically</label
                >
              </div>
            </div>
          </form>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem role="button" (click)="showHelpModal()">
            Viewer Help
          </a>
          @if (this.appService.appUser?.IsAdmin) {
            <div class="dropdown-divider"></div>
          }
          @if (this.appService.appUser?.IsAdmin) {
            <a ngbDropdownItem role="button" [routerLink]="['/admin']">
              Admin
            </a>
          }
        </div>
      </li>
    </ul>
  </div>
</nav>
<!-- End Navigation -->
